import { render, staticRenderFns } from "./MyMagazine.vue?vue&type=template&id=72083702"
import script from "./MyMagazine.vue?vue&type=script&lang=js"
export * from "./MyMagazine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports